module.exports = ":host {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.flex-wrap {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/vocabulary/components/vocabulary-dashboard.component.scss
// module id = ./src/app/vocabulary/components/vocabulary-dashboard.component.scss
// module chunks = main